import { Cohort } from "@/api/types";

type CheckboxProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
};

type CohortTileProps = {
  cohort: Cohort;
  selected?: boolean;
  disabled?: boolean;
  className?: string;
  onClick?: () => void;
  checkbox?: CheckboxProps;
};

const getCohortInitials = (name: string): string => {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) {
    return "CO";
  }
  if (words.length === 1) {
    return words[0].slice(0, 2).toUpperCase();
  }
  return `${words[0][0] || ""}${words[1][0] || ""}`.toUpperCase();
};

export default function CohortTile({
  cohort,
  selected = false,
  disabled = false,
  className = "",
  onClick,
  checkbox,
}: CohortTileProps) {
  const wrapperClassName = `rounded-lg border p-3 text-left transition ${
    selected ? "border-blue-300 bg-blue-50" : "border-gray-200 bg-white"
  } ${className}`;

  const content = (
    <div className="flex items-center gap-2">
      {checkbox && (
        <input
          id={`cohort-${cohort.id}`}
          type="checkbox"
          checked={checkbox.checked}
          onChange={(event) => checkbox.onChange(event.target.checked)}
          disabled={disabled}
          aria-label={checkbox.label}
        />
      )}

      <div className="flex h-9 w-9 items-center justify-center rounded-full bg-orange-100 text-xs font-semibold text-orange-800">
        {getCohortInitials(cohort.name)}
      </div>

      <div className="min-w-0">
        <div className="truncate text-sm font-medium text-gray-800">
          <label htmlFor={`cohort-${cohort.id}`} className="cursor-pointer">
          {cohort.name}
          </label>
        </div>
        {cohort.description && (
          <div className="line-clamp-2 text-xs text-gray-500">{cohort.description}</div>
        )}
      </div>
    </div>
  );

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        className={`${wrapperClassName} ${disabled ? "cursor-not-allowed opacity-50" : "hover:bg-gray-50"}`}
      >
        {content}
      </button>
    );
  }

  return <div className={wrapperClassName}>{content}</div>;
}